// extracted by mini-css-extract-plugin
module.exports = {"footer":"_ddc3c39"};